export const ROWS_COUNT = 10;
